module.exports = __webpack_public_path__ + "img/login.22cb6428.svg";